module.exports = __webpack_public_path__ + "img/location.b9ee5207.png";